import { useState } from "react";
import { Button, Col, Dropdown, Row, Spinner } from "react-bootstrap";
import RangeSlider from 'react-range-slider-input';
import "./InvoiceTable.css";
import PrivateApi from "../../../services/PrivateApiService";
import { useQueryClient } from "react-query";

const InvoiceTableFilters = ({filters, setFilters, downloadList}) => {
    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

    const documentFromHandler = (docFrom) => {
        if (docFrom === filters.documentFrom) docFrom = null;

        setFilters({...filters, 
            documentFrom: docFrom
        });
    }

    const documentTypeHandler = (docType) => {
        if (docType === filters.documentType) docType = null;

        setFilters({...filters,
            documentType: docType
        });
    }

    const monthRangeHandler = (val) => {
        setFilters({...filters,
            monthRange: val
        });
    }

    const monthRangeDisplay = () => {
        let date1 = new Date();
        let date2 = new Date();
        date1.setMonth(filters.monthRange[0] - 1);
        date2.setMonth(filters.monthRange[1] - 1);
        let from = date1.toLocaleDateString('DE-de', {month: 'long'});
        let till = date2.toLocaleDateString('DE-de', {month: 'long'});
        return `${from} - ${till}`
    }

    const yearHandler = (year) => {
        if (year === filters.year) year = null;

        setFilters({...filters,
            year: year
        });
    }

    const isDownloadedHandler = (toggle) => {
        if (toggle === filters.isDownloaded) toggle = null;

        setFilters({...filters,
            isDownloaded: toggle
        });
    }

    const downloadBtnHandler = () => {
        setDownloadBtnLoading(true);
        console.log(downloadList.length);
        API.post_InvoiceDownload(downloadList)
            .then(res => {
                let data = res.data;
                queryClient.invalidateQueries("GET_BUILDING_INVOICES");
                setDownloadBtnLoading(false);
                if (data.files === undefined) {
                    const linkSource = `data:application/pdf;base64,${data.file}`;
                    const fileName = data.name + '.pdf';
                    const downloadLink = document.createElement('a');

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                } else {
                    if (data.files.abrechnungen !== undefined) {
                        const linkSource = `data:application/zip;base64,${data.files.abrechnungen}`;
                        const fileName = data.files.abrechnungen_name;
                        const downloadLink = document.createElement('a');

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                    if (data.files.poolrechnungen !== undefined) {
                        const linkSource = `data:application/zip;base64,${data.files.poolrechnungen}`;
                        const fileName = data.files.poolrechnungen_name;
                        const downloadLink = document.createElement('a');

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                    if (data.files.vorschreibungen !== undefined) {
                        const linkSource = `data:application/zip;base64,${data.files.vorschreibungen}`;
                        const fileName = data.files.vorschreibungen_name;
                        const downloadLink = document.createElement('a');

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                }
            })
    }

    return (
        <>
            <Row>
                <Col>
                    <Dropdown>
                        <Dropdown.Toggle className="bg-transparent text-dark border-0">
                            {filters.documentFrom || "Dokument von"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item 
                                key={"energoDrop"} 
                                active={filters.documentFrom === "ENERGO"} 
                                onClick={() => documentFromHandler("ENERGO")}
                            >ENERGO</Dropdown.Item>
                            <Dropdown.Item 
                                key={"energieDrop"} 
                                active={filters.documentFrom === "Energielieferant"} 
                                onClick={() => documentFromHandler("Energielieferant")}
                            >Energielieferant</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col>
                    <Dropdown>
                        <Dropdown.Toggle>{ filters.documentType || "Rechnungsart" }</Dropdown.Toggle>
                        <Dropdown.Menu>
                            {filters.availableDocumentTypes.map(ad => (
                                <Dropdown.Item
                                    key={`key-${ad}`}
                                    active={ad === filters.documentType}
                                    onClick={() => documentTypeHandler(ad)}
                                >
                                    {ad}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col>
                    <div className="d-flex flex-column align-items-center">
                        <span>{monthRangeDisplay()}</span>
                        <RangeSlider 
                            value={filters.monthRange} onInput={monthRangeHandler}
                            step={1}
                            min={1}
                            max={12}
                        />
                    </div>
                </Col>
                <Col>
                    <Dropdown>
                        <Dropdown.Toggle>{ filters.year || "Jahr" }</Dropdown.Toggle>
                        <Dropdown.Menu>
                            {filters.availableYears.map(year => (
                                <Dropdown.Item 
                                    key={`yearKey-${year}`} 
                                    active={filters.year === year} 
                                    onClick={() => yearHandler(year)}
                                >
                                    {year}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col>
                    <Dropdown>
                        <Dropdown.Toggle>
                            {filters.isDownloaded === true? "Ja": filters.isDownloaded === false? "Nein" : "Downloaded"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item key={'downloadedYes'} active={filters.isDownloaded} onClick={() => isDownloadedHandler(true)}>Ja</Dropdown.Item>
                            <Dropdown.Item key={'downloadedNo'} active={filters.isDownloaded === false} onClick={() => isDownloadedHandler(false)}>Nein</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col hidden={downloadList.length === 0} >
                    <Button disabled={downloadBtnLoading} variant="energo" onClick={() => downloadBtnHandler()}>
                        {downloadBtnLoading ?
                            <Spinner animation="border" /> 
                            :
                            <>
                                Download ({downloadList.length})
                            </>
                        }
                    </Button>
                </Col>
            </Row>
        </>
    )
}
export default InvoiceTableFilters;